// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"50331bed","312":"5df2f403"}[chunkId] + ".chunk.css";
};